// PromoBanner action types

const promoBannerActionTypes = {
  SET_PROMO_BANNER_CONFIRMATION: 'SET_PROMO_BANNER_CONFIRMATION',
  DISMISS_PROMO_BANNER_CONFIRMATION: 'DISMISS_PROMO_BANNER_CONFIRMATION',
  CLEAR_PROMO_BANNER_CONFIRMATION: 'CLEAR_PROMO_BANNER_CONFIRMATION',
  BUMP_PROMO_SEARCH_TOKEN: 'BUMP_PROMO_SEARCH_TOKEN'
};

export default promoBannerActionTypes;
